module.exports = __webpack_public_path__ + "media/images/coral-b1ddf6c73eac603ecd882ee3a426c8b5.jpeg";